import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCode } from 'react-qrcode-logo';
import AppIcon from "../assets/sayq-fav.svg";
import MobileStatusIcons from "../assets/mobile_status_icons.png";
import PhoneMockup from "../assets/phone_mockup.png";
import SayQFunction from "../assets/quero_function-rev.jpg";
import CookieBanner from "../components/CookieBanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faComments, faPoll, faPalette, faCalendarAlt, faShieldAlt, faRocket,
    faArrowRight, faQrcode, faCheckCircle, faChalkboardTeacher, faChevronDown,
    faLaptopCode, faMobileAlt, faUsers, faSignal, faWifi, faBatteryFull,
    faList, faUser, faInfoCircle, faChevronLeft, faRedo, faEllipsisH,
    faUserSecret, faChartPie, faExchangeAlt, faTabletAlt, faCoffee, faThumbtack,
    faLock, faChevronRight, faShareSquare, faBookOpen, faClone,
    faBars, faSync, faPlus, faMugHot, faFilePdf, faFileArchive, faDownload, faFileAlt
} from "@fortawesome/free-solid-svg-icons";

const API = "https://api18081113.queroapp.pl/demo";

const MOCK_SEGMENTS = [
    { id: 'seg1', title: 'Otwarcie Konferencji i Keynote' },
    { id: 'seg2', title: 'Panel: Przyszłość AI w Biznesie' },
    { id: 'seg3', title: 'Warsztaty Design Thinking' },
    { id: 'seg4', title: 'Przerwa Networkingowa' },
    { id: 'seg5', title: 'Sesja Q&A i Zakończenie' }
];

const MOCK_MESSAGES = [
    { n: "Krystian12", m: "Czy prezentacja będzie dostępna w formacie PDF?" },
    { n: "Misiekgg", m: "Kiedy zaczyna się przerwa kawowa?" },
    { n: "Michalina", m: "Bardzo ciekawy temat, gratulacje!" },
    { n: "Użytkownik", m: "Ekstra animacja na ekranie! ✨" },
    { n: "Adam", m: "Jakie są wymagania techniczne dla API?" },
    { n: "Marta", m: "Czy można zadawać pytania anonimowo?" },
    { n: "Tomasz", m: "Świetna organizacja wydarzenia." },
    { n: "Ewa", m: "Czy nagranie z panelu będzie na YouTube?" },
    { n: "Piotr", m: "Jak zintegrować SayQ z moim CRM?" },
    { n: "Ania", m: "Pozdrowienia z Wrocławia! 👋" },
    { n: "Robert", m: "Czy planujecie wersję na rynek niemiecki?" },
    { n: "Sandra", m: "Najlepszy event w tym roku!" },
    { n: "Janusz", m: "Pytanie o skalowalność przy 10k userów." },
    { n: "Karolina", m: "Uwielbiam te animacje wiadomości." },
    { n: "Damian", m: "Jaki jest koszt pakietu Pro?" },
    { n: "Izabela", m: "Czekam na panel o marketingu w AI." },
    { n: "Łukasz", m: "Bardzo intuicyjny interfejs guest view." },
    { n: "Monika", m: "Czy można zmienić logo w aplikacji?" },
    { n: "Krzysiek", m: "Działa super szybko na moim starym iPhone." },
    { n: "Agnieszka", m: "Dziękuję za merytoryczne odpowiedzi." },
    { n: "Paweł", m: "Czy SayQ wspiera logowanie przez SSO?" },
    { n: "Kinga", m: "Najbardziej podoba mi się brak instalacji." },
    { n: "Grzegorz", m: "Pytanie do prelegenta nr 3." },
    { n: "Oliwia", m: "Czy ankiety są widoczne w czasie rzeczywistym?" },
    { n: "Marek", m: "Fajny design, bardzo nowoczesny." },
    { n: "Basia", m: "Mam problem z kodem QR, co zrobić?" },
    { n: "Wojtek", m: "Ile sesji można odpalić jednocześnie?" },
    { n: "Kamila", m: "Cześć wszystkim, miło was widzieć!" },
    { n: "Szymon", m: "Czy dane są przechowywane w UE?" },
    { n: "Patrycja", m: "Zaraz wracam, muszę dokończyć networking." },
    { n: "Zofia", m: "Bardzo przydatne narzędzie dla HR." },
    { n: "Mateusz", m: "Przesłałem 3 pytania, czekam na odpowiedź." },
    { n: "Mikołaj", m: "Wow, ale to płynnie działa." },
    { n: "Hubert", m: "Projekt SayQ to sztos." },
    { n: "Dominika", m: "Będą kody zniżkowe na następny event?" },
    { n: "Maciej", m: "Obsługa segmentów to gamechanger." },
    { n: "Wiktoria", m: "Jak dodać moderatora do wydarzenia?" },
    { n: "Adrian", m: "Pozdro z backendu! 🚀" },
    { n: "Milena", m: "Dobra robota z tym UXem." },
    { n: "Filip", m: "Bardzo podoba mi się moderacja pytań." },
    { n: "Natasza", m: "Czy mogę wyeksportować raport po evencie?" },
    { n: "Olek", m: "Ile osób może być w jednym pokoju?" },
    { n: "Paulina", m: "Pytanie o integrację z Zoomem." },
    { n: "Jakub", m: "Czy system obsługuje wiele języków?" },
    { n: "Lidia", m: "Super sprawa z tymi segmentami agendy." },
    { n: "Bartek", m: "Fajnie, że nie trzeba zakładać konta." },
    { n: "Daria", m: "Czy to bezpieczne dla korpo danych?" },
    { n: "Gabriel", m: "Uwielbiam ten tryb ciemny." },
    { n: "Joanna", m: "Pytanie o personalizację domen." },
    { n: "Rafał", m: "Najlepszy start firmy w 2024!" },
    { n: "Konto_1", m: "Zapraszam na stoisko nr 5 na bezpłatne konsultacje!" },
    { n: "EventMaster", m: "Czy jest lista uczestników na LinkedIn?" },
    { n: "Zuzanna", m: "Mam pytanie dotyczące segmentu Meta Ads." },
    { n: "Patryk", m: "Super sprawa z tymi ankietami na żywo." },
    { n: "Weronika", m: "Czy prelegent mówi po polsku czy po angielsku?" },
    { n: "Marcin", m: "Gdzie znajdę plan budynku?" },
    { n: "Ola_G", m: "Bardzo inspirujący wykład, dziękuję!" },
    { n: "Tomek_Tech", m: "Fajny stos technologiczny SayQ." },
    { n: "Beata", m: "Czy przerwę można wydłużyć o 10 minut?" },
    { n: "Krzysztof", m: "Pytanie o bezpieczeństwo danych w chmurze." },
    { n: "Dagmara", m: "Czy SayQ działa bez internetu (LAN)?" },
    { n: "Artur", m: "Pozdrowienia dla prelegenta z Gdańska!" },
    { n: "Sylwia", m: "Bardzo przejrzysty widok agendy." },
    { n: "Borys", m: "Ile trwa standardowa konfiguracja?" },
    { n: "Maja", m: "Czy są jakieś materiały drukowane?" },
    { n: "Konrad", m: "Świetna dynamika panelu dyskusyjnego." },
    { n: "Natalia", m: "Jakie inne moduły planujecie dodać?" },
    { n: "Grzesiek", m: "Czy można przesyłać zdjęcia w czacie?" },
    { n: "Hania", m: "Najlepszy UX ze wszystkich apek eventowych." },
    { n: "Radek", m: "Ile to kosztuje dla małego NGO?" },
    { n: "Oliwia_S", m: "Czekam na następną prelekcję o AI." },
    { n: "Michał_G", m: "System moderacji to czysty profesjonalizm." },
    { n: "Kalina", m: "Czy SayQ ma wersję White Label?" },
    { n: "Bartek_B", m: "Fajne powiadomienia o zmianach w agendzie." },
    { n: "Justyna", m: "Czy mogę zapisać ulubione prelekcje?" },
    { n: "Darek", m: "Pozdrowienia z backstage'u! 🎥" },
    { n: "Emilia", m: "Bardzo smaczna kawa na przerwie!" },
    { n: "Arek", m: "Pytanie o połączenie z systemem biletowym." },
    { n: "Anita", m: "Czy ankiety są anonimowe?" },
    { n: "Stefan", m: "Działa błyskawicznie, brawo!" },
    { n: "Karol", m: "Szukam kogoś do współpracy przy projekcie VR." },
    { n: "Gabi", m: "Dziękuję za odpowiedź na moje pytanie!" },
    { n: "Mariusz", m: "Czy moderacja może działać w zespole 3 osób?" },
    { n: "Iga", m: "Uwielbiam te minimalistyczne ikony." },
    { n: "Sebastian", m: "Gdzie są toalety na tym piętrze?" },
    { n: "Kasia_P", m: "Bardzo wartościowy content merytoryczny." },
    { n: "Rafał_X", m: "Czy SayQ wspiera kody rabatowe?" },
    { n: "Lucyna", m: "Czy w aplikacji jest czat prywatny?" },
    { n: "Daniel", m: "Jakie są ograniczenia darmowej wersji?" },
    { n: "Marta_M", m: "Szukam agendy na jutro." },
    { n: "Tadziu", m: "Czy można pobrać listę pytań po evencie?" },
    { n: "Olga", m: "Niesamowita precyzja w ankietach." },
    { n: "Jacek", m: "Pytanie do managera produktu SayQ." },
    { n: "Klara", m: "Pozdrowienia z Sopotu! 🌊" },
    { n: "Przemek", m: "Tryb gościa to genialne rozwiązanie." },
    { n: "Wanda", m: "Czy jest dostępna pomoc techniczna na miejscu?" },
    { n: "Tymek", m: "Ile MB waży załadowanie aplikacji gościa?" },
    { n: "Julia", m: "Pytanie o dostępność na tablety." },
    { n: "Mirek", m: "Dobra robota z tymi segmentami." },
    { n: "Kasia_N", m: "Hej, czy ktoś chce pogadać o Meta Ads?" },
    { n: "Sławek", m: "Mamy record uczestników dzisiaj!" },
    { n: "Ilona", m: "Bardzo pomocny panel FAQ." },
    { n: "Andrzej", m: "Chciałbym wdrożyć SayQ w mojej firmie." },
    { n: "Marzenka", m: "Bardzo ładne kolory interfejsu." },
    { n: "Filip_W", m: "Czy jest opcja głosowania na pytania?" },
    { n: "Edyta", m: "Gdzie będzie kolacja integracyjna?" },
    { n: "Piotr_L", m: "Działa świetnie na Safari Mac." },
    { n: "Magda", m: "Jak długo sesja jest aktywna po evencie?" },
    { n: "Gienek", m: "Czy można ustawić własny URL?" },
    { n: "Kasia_W", m: "Pytanie o integrację z Google Calendar." },
    { n: "Rafał_G", m: "Event Roku! Gratulacje dla organizatorów." },
    { n: "Oskar", m: "Szukam kontaktu do prelegenta od AI." },
    { n: "Ewelina", m: "Czy można zadawać pytania głosowe?" },
    { n: "Tadeusz", m: "Pytanie o stabilność połączenia przy 4G." },
    { n: "Nina", m: "Super widżet na stronę internetową." },
    { n: "Kuba", m: "Jakie języki obsługuje panel admina?" },
    { n: "Lidka", m: "Zaraz zaczynamy panel dyskusyjny!" },
    { n: "Bogdan", m: "Czy SayQ ma API dla statystyk?" },
    { n: "Monia", m: "Pozdrawiam wszystkich prelegentów!" },
    { n: "Szymek", m: "Czy dane są szyfrowane?" },
    { n: "Marlena", m: "Dziękuję za świetne prelekcje." },
    { n: "Kondzio", m: "Pytanie o tryb offline." },
    { n: "Zuzia", m: "Gdzie znajdę prezentację prelegenta 1?" },
    { n: "Olek_K", m: "Bardzo ciekawy case study." },
    { n: "Iwonka", m: "Pozdrowienia z Krakowa! 🥨" },
    { n: "Gracho", m: "Czy SayQ działa w Chinach?" },
    { n: "Alina", m: "Niesamowity design mobilny." },
    { n: "Dawid", m: "Jakie są plany na rozwój produktu?" },
    { n: "Sandra_M", m: "Czy można dodać sponsorów do agendy?" },
    { n: "Bolek", m: "Ile kosztuje licencja na 1 dzień?" },
    { n: "Teresa", m: "Czy wspieracie ankiety wielokrotnego wyboru?" },
    { n: "Romek", m: "Pytanie o dostępność archiwum." },
    { n: "Kasia_M", m: "Gdzie zaparkować samochód?" },
    { n: "Szymon_L", m: "Tryb moderacji to podstawa, super." },
    { n: "Basia_S", m: "Bardzo pomocny personel na miejscu." },
    { n: "Woytek", m: "Kiedy rusza sprzedaż biletów na 2025?" },
    { n: "Jola", m: "Czy można zmienić avatar w biegu?" },
    { n: "Stefek", m: "Bardzo płynne przejścia w aplikacji." },
    { n: "Klaudia", m: "Czy SayQ ma wbudowany tłumacz?" },
    { n: "Maurycy", m: "Pytanie o integrację z Hubspot." },
    { n: "Oliwka", m: "Bardzo miła atmosfera wydarzenia." },
    { n: "Kamil", m: "Pozdro dla QA! 🐛" },
    { n: "Malgosia", m: "Czy można eksportować do Excela?" },
    { n: "Rysiek", m: "Ile osób buduje SayQ?" },
    { n: "Sonia", m: "Rewelacyjne wrażenia z użytkowania." },
    { n: "Benek", m: "Gdzie kupić taką koszulkę SayQ?" },
    { n: "Lila", m: "Dziękuję za zaproszenie!" },
    { n: "Wiesław", m: "Czy jest opcja ciemnego motywu?" },
    { n: "Fabian", m: "Super prelekcja o cyberbezpieczeństwie." },
    { n: "Mela", m: "Kiedy będzie kolejny LinkedIn Local?" },
    { n: "Olek_W", m: "Pytanie do organizatora o catering." },
    { n: "Ircia", m: "Pozdrowienia z Lublina!" },
    { n: "Santi", m: "Aplikacja śmiga jak szalona." },
    { n: "Kira", m: "Czy są jakieś zadania domowe? 😉" },
    { n: "Vito", m: "Świetna robota z tą animacją segmentów." },
    { n: "Gaja", m: "Jakie są wymiary bannerów reklamowych?" },
    { n: "Natan", m: "Czy SayQ to polski produkt?" },
    { n: "Inka", m: "Wszystko super zorganizowane." },
    { n: "Bruno", m: "Pytanie o limit znaków w wiadomości." },
    { n: "Kaja", m: "Pozdrawiam prowadzącego!" },
    { n: "Remik", m: "Działa bez zarzutu na moim tablecie." },
    { n: "Pola", m: "Czekam na warsztaty z Meta Ads." },
    { n: "Gucio", m: "Czy można wysłać feedback audio?" },
    { n: "Mina", m: "Bardzo przejrzysty widok panelu." },
    { n: "Krzys", m: "Jak połączyć SayQ z rzutnikiem?" },
    { n: "Ula", m: "Najlepszy event merytoryczny w jakim brałam udział." },
    { n: "Eryk", m: "Czy będzie podsumowanie w mailu?" },
    { n: "Maja_P", m: "Dziękuję za dzisiejsze inspiracje." },
    { n: "Tobiasz", m: "Pytanie o kompatybilność z Teams." },
    { n: "Sara", m: "Bardzo intuicyjny proces rejestracji." },
    { n: "Hugo", m: "Ile danych zużywa aplikacja?" },
    { n: "Tosia", m: "Czy są jakieś nagrody za aktywność?" },
    { n: "Leon", m: "Pozdrowienia dla wszystkich prelegentów." },
    { n: "Róża", m: "System bardzo przyjazny dla oka." },
    { n: "Olaf", m: "Jakie są plany na 2024 rok?" },
    { n: "Halszka", m: "Czy można dodać linki do pytań?" },
    { n: "Igor", m: "Pytanie o dostęp do statystyk na żywo." },
    { n: "Blanka", m: "Super sprawa z tymi QR kodami." },
    { n: "Kajtek", m: "Działa bardzo szybko, gratulacje." },
    { n: "Malwina", m: "Czy SayQ ma opcję ankiet zamkniętych?" },
    { n: "Ida", m: "Bardzo wartościowy czas spędzony tutaj." },
    { n: "Ksawery", m: "Pytanie o integrację z Trello." },
    { n: "Nel", m: "Dziękuję za merytorykę i profesjonalizm." },
    { n: "Gacek", m: "Pozdrowienia z Poznania!" },
    { n: "Larysa", m: "Czy jest możliwość zmiany koloru tła?" },
    { n: "Dorian", m: "Pytanie o liczbę dostępnych segmentów." },
    { n: "Alma", m: "Uwielbiam te interaktywne elementy." },
    { n: "Kori", m: "Bardzo dobra jakość dźwięku na sesjach." },
    { n: "Teo", m: "Czy SayQ wspiera Markdown?" },
    { n: "Aria", m: "Najlepszy event branżowy!" },
    { n: "Miron", m: "Gdzie znajdę kontakt do moderatora?" },
    { n: "Zora", m: "Pozdrawiam z Łodzi!" },
    { n: "Aras", m: "Czy system jest dostępny w wersji on-premise?" },
    { n: "Ines", m: "Wszystko działa idealnie, brawo dla devów!" },
    { n: "Teodor", m: "Czy planujecie moduł quizów?" },
    { n: "Kalina_W", m: "Bardzo miła niespodzianka z tym demo." },
    { n: "Nico", m: "Najlepsze narzędzie do Q&A na rynku." },
    { n: "Luna", m: "Dziękuję za owocne rozmowy w kuluarach." },
    { n: "Borys_T", m: "System SayQ to strzał w dziesiątkę!" }
];

export default function LandingPage() {
    const navigate = useNavigate();
    const [sessionId, setSessionId] = useState(null);
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openFaq, setOpenFaq] = useState(null);
    const [streamMessages, setStreamMessages] = useState(MOCK_MESSAGES.slice(0, 6).map((m, i) => ({ ...m, id: `init-${i}` })));
    const [exitingIds, setExitingIds] = useState([]);
    const streamIndexRef = useRef(6);
    const [activeSegmentId, setActiveSegmentId] = useState('seg2');
    const [isCopied, setIsCopied] = useState(false);

    // Polling Ref
    const pollInterval = useRef(null);
    const demoSectionRef = useRef(null);

    const startDemo = async () => {
        if (loading || sessionId) return;
        setLoading(true);
        try {
            const res = await fetch(`${API}/init`, { method: 'POST' });
            const data = await res.json();
            if (data.success) {
                setSessionId(data.session_id);
                localStorage.setItem('demo_session', data.session_id);
                startPolling(data.session_id);
                setTimeout(() => {
                    document.getElementById('demo-section').scrollIntoView({ behavior: 'smooth' });
                }, 100);
            }
        } catch (err) {
            console.error("Demo Init Error:", err);
        } finally {
            setLoading(false);
        }
    };

    const startPolling = (sId) => {
        if (pollInterval.current) clearInterval(pollInterval.current);
        pollInterval.current = setInterval(async () => {
            try {
                const res = await fetch(`${API}/stream?session_id=${sId}`);
                if (res.ok) {
                    const data = await res.json();
                    if (data.messages) {
                        setMessages(data.messages);
                    }
                } else {
                    if (res.status === 404) {
                        clearInterval(pollInterval.current);
                        setSessionId(null);
                    }
                }
            } catch (err) {
                console.error("Polling Error:", err);
            }
        }, 2000);
    };

    // Auto-stream messages for mockup
    useEffect(() => {
        const interval = setInterval(() => {
            setStreamMessages(curr => {
                if (curr.length === 0) return curr;
                const firstId = curr[0].id;
                setExitingIds(prev => [...prev, firstId]);
                const nextMsg = {
                    ...MOCK_MESSAGES[streamIndexRef.current],
                    id: `msg-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
                };
                streamIndexRef.current = (streamIndexRef.current + 1) % MOCK_MESSAGES.length;
                setTimeout(() => {
                    setStreamMessages(latestCurr => latestCurr.filter(m => m.id !== firstId));
                    setExitingIds(prev => prev.filter(id => id !== firstId));
                }, 800);
                return [...curr, nextMsg];
            });
        }, 3500);
        return () => clearInterval(interval);
    }, []);

    // Auto-cycle segments for mockup
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSegmentId(curr => {
                const currentIndex = MOCK_SEGMENTS.findIndex(s => s.id === curr);
                const nextIndex = (currentIndex + 1) % MOCK_SEGMENTS.length;
                return MOCK_SEGMENTS[nextIndex].id;
            });
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    // Auto-start demo when section is visible
    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !sessionId && !loading) {
                startDemo();
            }
        }, { threshold: 0.1 });

        if (demoSectionRef.current) {
            observer.observe(demoSectionRef.current);
        }
        return () => observer.disconnect();
    }, [sessionId, loading]);

    useEffect(() => {
        return () => {
            if (pollInterval.current) clearInterval(pollInterval.current);
        };
    }, []);

    useEffect(() => {
        const saved = localStorage.getItem('demo_session');
        if (saved) {
            setSessionId(saved);
            startPolling(saved);
        }
    }, []);

    const guestUrl = sessionId ? `${window.location.origin}/demo-guest?session=${sessionId}` : "";

    const toggleFaq = (index) => {
        if (openFaq === index) {
            setOpenFaq(null);
        } else {
            setOpenFaq(index);
        }
    };

    const faqs = [
        {
            q: "Czy uczestnicy muszą instalować aplikację?",
            a: "Absolutnie nie! SayQ działa w 100% w przeglądarce. Wystarczy zeskanować kod QR lub wejść na krótki link, aby natychmiast dołączyć do sesji – bez rejestracji, bez pobierania."
        },
        {
            q: "Jak długo trwa konfiguracja wydarzenia?",
            a: "Samo założenie wydarzenia, wgranie logo i dobór kolorów zajmuje nie więcej niż 3 minuty. Możesz je przygotować z wyprzedzeniem i aktywować jednym kliknięciem tuż przed startem."
        },
        {
            q: "Czy mam pełną kontrolę nad pytaniami uczestników?",
            a: "Tak. Domyślnie tryb moderacji jest włączony – możesz akceptować, odrzucać, edytować lub przypinać pytania zanim pojawią się na ekranie prelegenta. Masz pełną kontrolę nad tym, co widzi sala."
        },
        {
            q: "Czym są Segmenty wydarzenia?",
            a: "Segmenty to oddzielne pokoje Q&A w ramach jednego wydarzenia – np. dla każdego prelegenta lub panelu. Jedno kliknięcie przełącza aktywny segment, a pytania automatycznie trafiają do właściwej osoby."
        },
        {
            q: "Czy mogę przeprowadzić ankietę podczas wydarzenia?",
            a: "Tak! SayQ pozwala tworzyć ankiety z wieloma wariantami odpowiedzi i uruchamiać je na żywo. Wyniki aktualizują się w czasie rzeczywistym i są widoczne zarówno dla Ciebie, jak i uczestników."
        },
        {
            q: "Co to jest Tryb Prelegenta?",
            a: "Tryb Prelegenta to specjalny widok przeznaczony na tablet lub laptop prelegenta. Wyświetla on tylko zatwierdzone pytania w czytelnym formacie, bez żadnych elementów panelu organizatora."
        },
        {
            q: "Czy SayQ poradzi sobie z dużą liczbą uczestników?",
            a: "SayQ zostało zaprojektowane do obsługi dużego ruchu. Nasza infrastruktura chmurowa radzi sobie z tysiącami jednoczesnych połączeń bez opóźnień – nawet na dużych konferencjach."
        },
        {
            q: "Czy mogę dostosować wygląd aplikacji do swojego brandu?",
            a: "Tak – możesz wgrać logo, ustawić kolory motywu (tło, akcenty) i spersonalizować ekran gościa. Uczestnicy zobaczą markę Twojego wydarzenia, nie SayQ."
        },
        {
            q: "Jak wygląda cennik i czy jest darmowy okres próbny?",
            a: "Tak! Po rejestracji masz 2 dni pełnego dostępu za darmo – bez karty kredytowej. Po tym czasie możesz skontaktować się z nami, aby wykupić licencję na konkretne wydarzenie lub abonament."
        },
        {
            q: "Czy mogę zobaczyć statystyki po wydarzeniu?",
            a: "Tak – SayQ rejestruje liczbę pytań, aktywność uczestników, wyniki ankiet i wiele innych metryk. Dane dostępne są w panelu organizatora po zakończeniu sesji."
        }
    ];

    const handleCopyLink = () => {
        if (!guestUrl) return;
        navigator.clipboard.writeText(guestUrl).then(() => {
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        });
    };

    return (
        <div
            className="bg-light font-sans text-dark page-landing"
            style={{
                minHeight: '100vh',
                display: 'block',
                position: 'relative',
                overflowX: 'hidden'
            }}
        >
            <CookieBanner />
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg bg-white bg-opacity-90 backdrop-blur fixed-top shadow-sm px-4 py-3 d-flex justify-content-between z-1000">
                <div className="d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={() => window.scrollTo(0, 0)}>
                    <img src="/sayq-fav.svg" alt="SayQ" style={{ height: 42, objectFit: 'contain', flexShrink: 0 }} />
                    <span className="fs-4" style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, letterSpacing: '-0.2px' }}>SayQ</span>
                </div>
                <div className="d-flex gap-4 align-items-center">
                    <a href="#faq" className="text-secondary fw-semibold text-decoration-none d-none d-md-block hover-text-primary transition-all">FAQ</a>
                    <span onClick={() => navigate('/kontakt')} className="text-secondary fw-semibold text-decoration-none d-none d-md-block hover-text-primary transition-all" style={{ cursor: 'pointer' }}>Kontakt</span>
                    <button
                        onClick={() => navigate('/login')}
                        className="btn btn-outline-primary rounded-pill px-4 fw-bold hover-lift"
                    >
                        Panel Organizatora
                    </button>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="hero-section text-center position-relative d-flex align-items-center justify-content-center pt-5 pb-5 overflow-hidden" style={{ minHeight: '90vh', background: 'linear-gradient(155deg, #f0f4ff 0%, #f8f9fa 50%, #eef6ff 100%)', marginTop: '72px' }}>

                {/* Background gradient blobs */}
                <div className="position-absolute" style={{ top: '-80px', left: '-120px', width: '500px', height: '500px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(13,110,253,0.08) 0%, transparent 70%)', zIndex: 0 }}></div>
                <div className="position-absolute" style={{ bottom: '-60px', right: '-100px', width: '420px', height: '420px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(13,202,240,0.07) 0%, transparent 70%)', zIndex: 0 }}></div>
                <div className="position-absolute" style={{ top: '40%', left: '40%', width: '300px', height: '300px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(111,66,193,0.04) 0%, transparent 70%)', zIndex: 0 }}></div>

                {/* Floating card – left: live question */}
                <div className="position-absolute d-none d-xl-block animate-float" style={{ left: '4%', top: '28%', zIndex: 2 }}>
                    <div className="bg-white rounded-4 shadow-lg p-3 d-flex align-items-center gap-3" style={{ minWidth: '220px', border: '1px solid rgba(13,110,253,0.1)' }}>
                        <div className="rounded-3 bg-primary bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 40, height: 40 }}>
                            <FontAwesomeIcon icon={faComments} className="text-primary" />
                        </div>
                        <div className="text-start">
                            <div className="fw-bold text-dark" style={{ fontSize: '0.85rem' }}>Nowe pytanie</div>
                            <div className="text-secondary" style={{ fontSize: '0.75rem' }}>Kiedy zaczniemy warsztaty?</div>
                        </div>
                        <div className="rounded-circle bg-success flex-shrink-0" style={{ width: 8, height: 8 }}></div>
                    </div>
                </div>

                {/* Floating card – left bottom: participant count */}
                <div className="position-absolute d-none d-xl-block animate-float" style={{ left: '5%', top: '55%', zIndex: 2, animationDelay: '0.5s' }}>
                    <div className="bg-white rounded-4 shadow p-3" style={{ minWidth: '160px', border: '1px solid #f0f0f0' }}>
                        <div className="text-muted small mb-1">Uczestnicy online</div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="fw-bold text-dark" style={{ fontSize: '1.6rem' }}>247</span>
                            <span className="badge bg-success-subtle text-success rounded-pill small">↑ na żywo</span>
                        </div>
                    </div>
                </div>

                {/* Floating card – right: poll result */}
                <div className="position-absolute d-none d-xl-block animate-float" style={{ right: '4%', top: '25%', zIndex: 2, animationDelay: '0.8s' }}>
                    <div className="bg-white rounded-4 shadow-lg p-3" style={{ minWidth: '210px', border: '1px solid rgba(13,110,253,0.1)' }}>
                        <div className="d-flex align-items-center gap-2 mb-2">
                            <div className="rounded-3 bg-warning bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 30, height: 30 }}>
                                <FontAwesomeIcon icon={faPoll} className="text-warning" style={{ fontSize: '0.8rem' }} />
                            </div>
                            <span className="text-muted small fw-bold">Wyniki ankiety</span>
                        </div>
                        <div className="mb-2">
                            <div className="d-flex justify-content-between small mb-1">
                                <span>Opcja A</span><span className="fw-bold">62%</span>
                            </div>
                            <div className="rounded-pill bg-light overflow-hidden" style={{ height: 6 }}>
                                <div className="rounded-pill bg-primary h-100" style={{ width: '62%' }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex justify-content-between small mb-1">
                                <span>Opcja B</span><span className="fw-bold">38%</span>
                            </div>
                            <div className="rounded-pill bg-light overflow-hidden" style={{ height: 6 }}>
                                <div className="rounded-pill bg-info h-100" style={{ width: '38%' }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Floating card – right bottom: break mode */}
                <div className="position-absolute d-none d-xl-block animate-float" style={{ right: '5%', top: '55%', zIndex: 2, animationDelay: '1.2s' }}>
                    <div className="bg-white rounded-4 shadow p-3 d-flex align-items-center gap-3" style={{ border: '1px solid #f0f0f0' }}>
                        <div className="rounded-3 bg-info bg-opacity-10 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 36, height: 36 }}>
                            <FontAwesomeIcon icon={faMugHot} className="text-info" />
                        </div>
                        <div>
                            <div className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>Przerwa kawowa</div>
                            <div className="text-muted" style={{ fontSize: '0.72rem' }}>Wrócimy o 15:30</div>
                        </div>
                    </div>
                </div>

                <div className="container position-relative z-1 pt-4">
                    <h1 className="display-2 fw-bold mb-4 tracking-tight animate-fade-in text-dark">
                        Zwiększ zaangażowanie <br className="d-none d-md-block" /> z <span className="text-primary">SayQ</span>
                    </h1>
                    <p className="lead text-secondary mb-5 mx-auto fw-medium animate-slide-up" style={{ maxWidth: '750px', fontSize: '1.25rem', lineHeight: '1.6' }}>
                        Narzekasz na cichą publiczność? SayQ to aplikacja webowa, która pozwala uczestnikom zadawać pytania i brać udział w ankietach bezpośrednio z ich smartfonów. Zawsze na czas, zawsze pod kontrolą.
                    </p>
                    <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        <button
                            onClick={() => document.querySelector('#demo-section')?.scrollIntoView({ behavior: 'smooth' })}
                            className="btn btn-primary btn-lg rounded-pill px-5 py-3 shadow-primary fw-bold hover-scale d-flex align-items-center justify-content-center gap-2"
                            style={{ fontSize: '1.1rem' }}
                        >
                            <span>Wypróbuj Demo <FontAwesomeIcon icon={faArrowRight} /></span>
                        </button>
                        <button
                            onClick={() => document.querySelector('#why')?.scrollIntoView({ behavior: 'smooth' })}
                            className="btn btn-white btn-lg rounded-pill px-5 py-3 shadow-sm border text-dark fw-bold hover-lift bg-white"
                            style={{ fontSize: '1.1rem' }}
                        >
                            Jak to działa?
                        </button>
                    </div>

                    {/* Social Proof Placeholder directly under Hero */}
                    <div className="mt-5 pt-5 opacity-50 animate-fade-in" style={{ animationDelay: '0.4s' }}>
                        <p className="small fw-bold text-uppercase tracking-tight mb-4">Zaufali nam eksperci z branży eventowej</p>
                        <div className="d-flex flex-wrap justify-content-center gap-4 gap-md-5 align-items-center grayscale">
                            <span className="fs-4 fw-bold" style={{ fontFamily: "'League Spartan', sans-serif" }}>TEDx Politechnika Gdańska</span>
                            <span className="fs-4 fw-bold" style={{ fontFamily: "'League Spartan', sans-serif" }}>Serial Networkers</span>
                            <span className="fs-4 fw-bold" style={{ fontFamily: "'League Spartan', sans-serif" }}>FutureFlow</span>
                            <span className="fs-4 fw-bold" style={{ fontFamily: "'League Spartan', sans-serif" }}>Dog Friendly Office</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Alternating Feature Blocks (Standard SaaS) - Realistic UI Edition */}
            <section id="why" className="py-5 bg-white border-bottom border-light">
                <div className="container py-5 mt-4">

                    {/* Block 1: Guest View (Mobile Phone Replica) */}
                    <div className="row align-items-center justify-content-between mb-5 pb-5">
                        <div className="col-lg-5 mb-5 mb-lg-0 pe-lg-5">
                            <div className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill fw-bold mb-3 ls-1">ZERO INSTALACJI</div>
                            <h2 className="display-6 fw-bold mb-4">Uczestnicy nie lubią pobierać zbędnych apek.</h2>
                            <p className="lead text-secondary mb-4">
                                By stać się częścią wydarzenia, nie musisz pobierać dedykowanych aplikacji na swój telefon. Wystarczy uruchomić aparat, zeskanować kod QR i już stajesz się częścią wydarzenia za pomocą przeglądarki w Twoim telefonie. A po wszystkim zamykasz kartę.
                            </p>
                            <ul className="list-unstyled d-flex flex-column gap-2 text-dark fw-medium mt-4" style={{ listStyle: "none" }}>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>100% użycie w przeglądarce (PWA)</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>Intuicyjny interfejs formularza</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>Automatyczne dopasowanie do każdego ekranu</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-center position-relative">
                            <div className="position-relative" style={{ width: '380px', height: '770px' }}>
                                {/* The Phone Mockup Frame */}
                                <img
                                    src={PhoneMockup}
                                    alt="Phone Mockup"
                                    className="w-100 h-100 position-relative z-2"
                                    style={{ objectFit: 'contain', pointerEvents: 'none', filter: 'drop-shadow(0 40px 100px rgba(0,0,0,0.25))' }}
                                />

                                {/* The "Screen" Content Overlay */}
                                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center" style={{ padding: '20px 24px' }}>
                                    <div className="bg-white w-100 h-100 overflow-hidden d-flex flex-column shadow-inner" style={{ borderRadius: '35px', marginTop: '5px', maxHeight: '98%' }}>
                                        {/* Status Bar */}
                                        <div className="px-4 pt-4 pb-2 d-flex justify-content-between align-items-center">
                                            <span className="fw-bold small" style={{ fontSize: '0.85rem' }}>9:41</span>
                                            <img src={MobileStatusIcons} alt="Status" style={{ height: '14px' }} />
                                        </div>

                                        {/* PRODUCTION CONTENT (from Chat.jsx) */}
                                        <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center px-3" style={{ backgroundColor: '#f5f7f9' }}>
                                            <div className="bg-white chat-panel-container d-flex flex-column align-items-center text-center animate-fade-in w-100"
                                                style={{
                                                    padding: '30px 24px',
                                                    borderRadius: '24px',
                                                    boxShadow: '0 20px 60px -10px rgba(0,0,0,0.08)'
                                                }}>
                                                <h2 className="fw-black mb-2 text-dark display-6" style={{ fontSize: '1.75rem' }}>Zadaj Pytanie</h2>
                                                <p className="text-secondary fw-medium mb-3" style={{ fontSize: '0.9rem' }}>
                                                    <span className="text-uppercase small fw-bold opacity-75 d-block mb-1" style={{ letterSpacing: '1px' }}>Dotyczy segmentu:</span>
                                                    <span className="text-primary fw-bold">Marketing 2025</span>
                                                </p>

                                                <div className="d-inline-flex align-items-center gap-2 px-3 py-2 mt-2 bg-light rounded-pill border border-light mb-4">
                                                    <img src="/mock_avatar.png" alt="Avatar" className="rounded-circle shadow-sm" style={{ width: 24, height: 24 }} />
                                                    <span className="fw-semibold text-dark small">Paweł Wymyślony</span>
                                                </div>

                                                <div className="w-100 mb-4">
                                                    <div className="form-control border-2 text-start p-3" style={{ minHeight: '140px', borderRadius: '18px', borderColor: '#dee2e6' }}>
                                                        <span className="text-muted small">O co chcesz zapytać?</span>
                                                    </div>
                                                </div>

                                                <button className="btn btn-primary w-100 py-3 rounded-pill fw-bold shadow-sm text-uppercase" style={{ letterSpacing: '0.5px' }}>
                                                    Wyślij pytanie
                                                </button>
                                            </div>
                                        </div>

                                        <div className="position-absolute bottom-0 start-0 w-100 pb-5 d-flex align-items-center justify-content-between z-3"
                                            style={{ paddingLeft: '42px', paddingRight: '42px' }}>
                                            {/* Back Button Circle */}
                                            <div className="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-lg border"
                                                style={{ width: '38px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
                                                <FontAwesomeIcon icon={faChevronLeft} className="text-secondary" style={{ fontSize: '0.85rem' }} />
                                            </div>

                                            {/* Main Floating Pill Address Bar - PERFECT iOS SAFARI LOOK */}
                                            <div className="flex-grow-1 mx-2 rounded-pill bg-white d-flex align-items-center px-3 shadow-lg border"
                                                style={{ height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)', maxWidth: '180px' }}>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '22px' }}>
                                                    <span className="text-dark fw-bold" style={{ fontSize: '0.8rem' }}>Aa</span>
                                                </div>
                                                <div className="flex-grow-1 d-flex align-items-center justify-content-center gap-1">
                                                    <FontAwesomeIcon icon={faLock} className="text-dark opacity-50" style={{ fontSize: '0.6rem' }} />
                                                    <span className="text-dark fw-bold" style={{ fontSize: '0.75rem' }}>queroapp.pl</span>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '22px' }}>
                                                    <FontAwesomeIcon icon={faSync} className="text-dark opacity-75" style={{ fontSize: '0.65rem' }} />
                                                </div>
                                            </div>

                                            {/* Menu Button Circle */}
                                            <div className="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-lg border"
                                                style={{ width: '38px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
                                                <FontAwesomeIcon icon={faEllipsisH} className="text-dark" style={{ fontSize: '0.85rem' }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row align-items-center justify-content-between flex-lg-row-reverse mb-5 pb-5">
                        <div className="col-lg-5 mb-4 mb-lg-0 ps-lg-5">
                            <div className="badge bg-dark text-white px-3 py-2 rounded-pill fw-bold mb-3 ls-1">PANEL PROWADZĄCEGO</div>
                            <h2 className="display-6 fw-bold mb-4">Pytania trafiają prosto do Ciebie.</h2>
                            <p className="lead text-secondary mb-4">
                                Każde pytanie trafia wprost na Twój ekran, zanim zobaczy je ktokolwiek inny. Decydujesz, które wchodzą na scenę, które czekają, a które nie przechodzą. Zero chaosu, pełna kontrola nad rozmową.
                            </p>
                            <a href="#demo-section" className="fw-bold text-decoration-none border-bottom border-primary pb-1 hover-text-primary">Wypróbuj panel moderatora <FontAwesomeIcon icon={faArrowRight} className="ms-1 small" /></a>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-center">
                            {/* Live Screen Dashboard Mockup */}
                            <div className="shadow-lg overflow-hidden position-relative d-flex flex-column"
                                style={{ width: '380px', height: '550px', borderRadius: '30px', backgroundColor: '#ebebeb', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>

                                {/* Content Area */}
                                <div className="p-4 flex-grow-1 d-flex flex-column position-relative z-1 pt-5">
                                    {/* Segment White Card - Highest Layer */}
                                    <div className="bg-white rounded-4 shadow-sm p-4 animate-slide-down position-relative" style={{ borderRadius: '25px', boxShadow: '0 4px 15px rgba(0,0,0,0.03)', zIndex: 10 }}>
                                        <div className="text-secondary fw-bold small mb-2" style={{ letterSpacing: '0.8px', fontSize: '0.75rem', color: '#7a8289' }}>WIADOMOŚCI Z SEGMENTU:</div>
                                        <h4 className="fw-black text-dark m-0 fs-3 tracking-tight">Inteligentne kampanie Meta Ads</h4>
                                    </div>

                                    {/* Top Blur Mask - Placed BELOW the card, masking messages as they slide behind it */}
                                    <div className="position-absolute w-100" style={{ top: '155px', height: '80px', background: 'linear-gradient(to bottom, #ebebeb 10%, transparent 100%)', zIndex: 5, left: 0 }}></div>

                                    {/* Messages list - Slides UP behind the card and its blur mask */}
                                    <div className="d-flex flex-column px-3 position-relative flex-grow-1" style={{ zIndex: 1, marginTop: '-30px', paddingBottom: '30px' }}>
                                        {streamMessages.map((msg) => (
                                            <div key={msg.id} className={`simulated-message ${exitingIds.includes(msg.id) ? 'exiting' : ''}`} style={{ marginBottom: '1.2rem' }}>
                                                <span className="simulated-message-name">{msg.n}:</span>{" "}
                                                <span className="simulated-message-text">{msg.m}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {/* Block 3: Event Segments View */}
                    <div className="row align-items-center justify-content-between mb-5 pb-5">
                        <div className="col-lg-5 mb-4 mb-lg-0 pe-lg-5">
                            <div className="badge bg-primary text-white px-3 py-2 rounded-pill fw-bold mb-3 ls-1">SEGMENTY WYDARZENIA</div>
                            <h2 className="display-6 fw-bold mb-4">Każde pytanie trafia do właściwego prelegenta.</h2>
                            <p className="lead text-secondary mb-4">
                                Każdy segment to osobny pokój do zadawania pytań. Uczestnicy widzą dokładnie, czego dotyczy bieżąca dyskusja, a gdy prelegent się zmienia, prowadzący przełącza segment jednym kliknięciem. Żadnych pomyłek, żadnego bałaganu.
                            </p>
                            <div className="d-flex align-items-center gap-3 text-dark fw-bold">
                                <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white" style={{ width: '32px', height: '32px' }}>
                                    <FontAwesomeIcon icon={faPlus} size="xs" />
                                </div>
                                Błyskawiczne dodawanie nowych bloków
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-center">
                            {/* Segments Management Mockup */}
                            <div className="shadow-lg p-4 d-flex flex-column"
                                style={{ width: '450px', borderRadius: '30px', backgroundColor: '#f8f9fa', border: '1px solid rgba(0,0,0,0.05)' }}>
                                <div className="d-flex justify-content-between align-items-center mb-4 px-2">
                                    <h5 className="fw-bold m-0 text-secondary">Segmenty Wydarzenia</h5>
                                    <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center text-white shadow-sm" style={{ width: '35px', height: '35px' }}>
                                        <FontAwesomeIcon icon={faPlus} />
                                    </div>
                                </div>

                                <div className="d-flex flex-column gap-3">
                                    {MOCK_SEGMENTS.map((seg) => (
                                        <div key={seg.id}
                                            className={`segment-mock-row d-flex align-items-center justify-content-between p-3 bg-white border transition-all ${activeSegmentId === seg.id ? 'active-segment-row' : 'inactive-segment-row'}`}
                                            style={{ borderRadius: '18px', boxShadow: '0 15px 35px -5px rgba(0,0,0,0.07), 0 10px 15px -5px rgba(0,0,0,0.04)' }}>
                                            <span className={`fw-bold small ${activeSegmentId === seg.id ? 'text-dark' : 'text-secondary opacity-75'}`} style={{ maxWidth: '80%' }}>
                                                {seg.title}
                                            </span>
                                            <div className={`mock-switch ${activeSegmentId === seg.id ? 'active' : ''}`}>
                                                <div className="mock-switch-handle"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Block 4: Break Segment View */}
                    <div className="row align-items-center justify-content-between flex-lg-row-reverse mb-5 pb-5">
                        <div className="col-lg-5 mb-4 mb-lg-0 ps-lg-5">
                            <div className="badge bg-info bg-opacity-10 text-info px-3 py-2 rounded-pill fw-bold mb-3 ls-1">PRZERWY I CZAS</div>
                            <h2 className="display-6 fw-bold mb-4">A gdy czas na kawkę...</h2>
                            <p className="lead text-secondary mb-4">
                                Poinformuj uczestników o przerwie jednym kliknięciem. Ustaw, o której przerwa się wyłączy, a SayQ zadba o resztę automatycznie. Dostosujesz też treść powiadomienia – zamiast standardowego komunikatu możesz wpisać coś bardziej osobistego, np. „Wróćcie o 15:30 z kubkiem w dłoni 🍵”.
                            </p>
                            <div className="d-flex align-items-center gap-3 text-dark fw-bold">
                                <div className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center text-info" style={{ width: '32px', height: '32px' }}>
                                    <FontAwesomeIcon icon={faCoffee} size="xs" />
                                </div>
                                Dedykowane ekrany przerw
                            </div>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-center position-relative">
                            <div className="position-relative" style={{ width: '380px', height: '770px' }}>
                                {/* The Phone Mockup Frame */}
                                <img
                                    src={PhoneMockup}
                                    alt="Phone Mockup"
                                    className="w-100 h-100 position-relative z-2"
                                    style={{ objectFit: 'contain', pointerEvents: 'none', filter: 'drop-shadow(0 40px 100px rgba(0,0,0,0.25))' }}
                                />

                                {/* The "Screen" Content Overlay */}
                                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center" style={{ padding: '20px 24px' }}>
                                    <div className="bg-white w-100 h-100 overflow-hidden d-flex flex-column shadow-inner" style={{ borderRadius: '35px', marginTop: '5px', maxHeight: '98%' }}>
                                        {/* Status Bar */}
                                        <div className="px-4 pt-4 pb-2 d-flex justify-content-between align-items-center">
                                            <span className="fw-bold small" style={{ fontSize: '0.85rem' }}>9:41</span>
                                            <img src={MobileStatusIcons} alt="Status" style={{ height: '14px' }} />
                                        </div>

                                        {/* PRODUCTION BREAK CONTAINER (from Chat.jsx) */}
                                        <div className="flex-grow-1 d-flex flex-column align-items-center justify-content-center px-3" style={{ backgroundColor: '#f5f7f9' }}>
                                            <div className="bg-white chat-panel-container d-flex flex-column align-items-center text-center animate-fade-in w-100"
                                                style={{
                                                    padding: '40px 24px',
                                                    borderRadius: '24px',
                                                    boxShadow: '0 20px 60px -10px rgba(0,0,0,0.08)'
                                                }}>
                                                <div className="mb-4 text-primary opacity-75" style={{ animation: 'pulse 2s infinite' }}>
                                                    <FontAwesomeIcon icon={faMugHot} size="4x" />
                                                </div>
                                                <h2 className="fw-bold mb-3 text-dark text-break" style={{ fontSize: '1.75rem' }}>
                                                    Trwa przerwa kawowa. Wracamy za chwilę!
                                                </h2>
                                                <p className="text-secondary fw-medium">Zadawanie pytań jest wstrzymane.</p>
                                            </div>
                                        </div>


                                        {/* PERFECT iOS SAFARI UI FOR BLOCK 4 */}
                                        <div className="position-absolute bottom-0 start-0 w-100 pb-5 d-flex align-items-center justify-content-between z-3"
                                            style={{ paddingLeft: '42px', paddingRight: '42px' }}>
                                            {/* Back Button Circle */}
                                            <div className="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-lg border"
                                                style={{ width: '38px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
                                                <FontAwesomeIcon icon={faChevronLeft} className="text-secondary" style={{ fontSize: '0.85rem' }} />
                                            </div>

                                            {/* Main Floating Pill Address Bar */}
                                            <div className="flex-grow-1 mx-2 rounded-pill bg-white d-flex align-items-center px-3 shadow-lg border"
                                                style={{ height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)', maxWidth: '180px' }}>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '22px' }}>
                                                    <span className="text-dark fw-bold" style={{ fontSize: '0.8rem' }}>Aa</span>
                                                </div>
                                                <div className="flex-grow-1 d-flex align-items-center justify-content-center gap-1">
                                                    <FontAwesomeIcon icon={faLock} className="text-dark opacity-50" style={{ fontSize: '0.6rem' }} />
                                                    <span className="text-dark fw-bold" style={{ fontSize: '0.75rem' }}>queroapp.pl</span>
                                                </div>
                                                <div className="d-flex align-items-center justify-content-center" style={{ width: '22px' }}>
                                                    <FontAwesomeIcon icon={faSync} className="text-dark opacity-75" style={{ fontSize: '0.65rem' }} />
                                                </div>
                                            </div>

                                            {/* Menu Button Circle */}
                                            <div className="rounded-circle bg-white d-flex align-items-center justify-content-center shadow-lg border"
                                                style={{ width: '38px', height: '38px', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
                                                <FontAwesomeIcon icon={faEllipsisH} className="text-dark" style={{ fontSize: '0.85rem' }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Block 5 - Statistics and Reports */}
            <section id="stats" className="py-5 position-relative" style={{ backgroundColor: '#ffffff' }}>
                <div className="container py-5">
                    <div className="row align-items-center justify-content-between mb-5">
                        <div className="col-lg-5 mb-5 mb-lg-0">
                            <div className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill fw-bold mb-3 ls-1">ANALITYKA I RAPORTY</div>
                            <h2 className="display-6 fw-bold mb-4">Wiedza, która buduje lepsze wydarzenia.</h2>
                            <p className="lead text-secondary mb-4">
                                Poznaj zachowania swoich odbiorców dzięki szczegółowym statystykom. Śledź aktywność w czasie rzeczywistym i generuj profesjonalne raporty, które pomogą Ci zmierzyć sukces Twojego eventu.
                            </p>
                            <ul className="list-unstyled d-flex flex-column gap-2 text-dark fw-medium mt-4" style={{ listStyle: "none" }}>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>Raporty w czasie rzeczywistym</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>Szczegółowe zestawienia segmentów</span>
                                </li>
                                <li className="d-flex align-items-center">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-success me-3" />
                                    <span>Eksport do PDF i ZIP za jednym kliknięciem</span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-7">
                            <div className="bg-light p-4 p-md-5 rounded-5" style={{ backgroundColor: '#f8f9fa', boxShadow: '0 30px 70px -15px rgba(0,0,0,0.25)' }}>
                                {/* Top Stats Grid */}
                                <div className="row g-3 mb-4">
                                    <div className="col-6 col-md-3">
                                        <div className="bg-white p-3 rounded-4 border h-100" style={{ boxShadow: '0 20px 45px rgba(0,0,0,0.15)' }}>
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                    <FontAwesomeIcon icon={faComments} size="xs" />
                                                </div>
                                                <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Wiadomości</span>
                                            </div>
                                            <div className="h3 fw-black m-0">18</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="bg-white p-3 rounded-4 border h-100" style={{ boxShadow: '0 20px 45px rgba(0,0,0,0.15)' }}>
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <div className="bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                    <FontAwesomeIcon icon={faUsers} size="xs" />
                                                </div>
                                                <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Uczestnicy</span>
                                            </div>
                                            <div className="h3 fw-black m-0">13</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="bg-white p-3 rounded-4 border h-100" style={{ boxShadow: '0 20px 45px rgba(0,0,0,0.15)' }}>
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <div className="bg-danger bg-opacity-10 text-danger rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                    <FontAwesomeIcon icon={faChartPie} size="xs" />
                                                </div>
                                                <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Rekord Online</span>
                                            </div>
                                            <div className="h3 fw-black m-0">3</div>
                                            <div className="text-muted" style={{ fontSize: '0.6rem' }}>max w jednej chwili (sesja)</div>
                                        </div>
                                    </div>
                                    <div className="col-6 col-md-3">
                                        <div className="bg-white p-3 rounded-4 border h-100" style={{ boxShadow: '0 20px 45px rgba(0,0,0,0.15)' }}>
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                <div className="bg-warning bg-opacity-10 text-warning rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                    <FontAwesomeIcon icon={faPoll} size="xs" />
                                                </div>
                                                <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Ankiety</span>
                                            </div>
                                            <div className="h3 fw-black m-0">4</div>
                                        </div>
                                    </div>
                                </div>

                                {/* Main Dashboard row */}
                                <div className="row g-4">
                                    {/* Pie Chart Card */}
                                    <div className="col-md-7">
                                        <div className="bg-white p-4 rounded-5 border h-100" style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.2)' }}>
                                            <h5 className="fw-bold mb-4 x-small text-dark opacity-75 text-uppercase ls-1">Aktywność w segmentach</h5>
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="position-relative mb-4" style={{ width: '180px', height: '180px' }}>
                                                    <svg viewBox="0 0 36 36" className="w-100 h-100">
                                                        {/* Background track */}
                                                        <circle cx="18" cy="18" r="16" fill="transparent" stroke="#f1f3f5" strokeWidth="4"></circle>
                                                        {/* Seg 1: blue 40% — dash=38.9, gap=61.6, offset=0 (starts at 12 o'clock) */}
                                                        <circle cx="18" cy="18" r="16" fill="transparent" stroke="#0d6efd" strokeWidth="3.5"
                                                            strokeDasharray="38.9 61.6" strokeDashoffset="0"
                                                            transform="rotate(-90 18 18)"></circle>
                                                        {/* Seg 2: dark-purple 25% — starts at 39.7, offset=-39.7 */}
                                                        <circle cx="18" cy="18" r="16" fill="transparent" stroke="#6610f2" strokeWidth="3.5"
                                                            strokeDasharray="24.3 76.3" strokeDashoffset="-39.7"
                                                            transform="rotate(-90 18 18)"></circle>
                                                        {/* Seg 3: purple 20% — starts at 64.8, offset=-64.8 */}
                                                        <circle cx="18" cy="18" r="16" fill="transparent" stroke="#6f42c1" strokeWidth="3.5"
                                                            strokeDasharray="19.5 81.0" strokeDashoffset="-64.8"
                                                            transform="rotate(-90 18 18)"></circle>
                                                        {/* Seg 4: pink 15% — starts at 85.1, offset=-85.1 */}
                                                        <circle cx="18" cy="18" r="16" fill="transparent" stroke="#d63384" strokeWidth="3.5"
                                                            strokeDasharray="14.6 85.9" strokeDashoffset="-85.1"
                                                            transform="rotate(-90 18 18)"></circle>
                                                    </svg>
                                                </div>
                                                <div className="w-100">
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <div style={{ width: '12px', height: '12px', borderRadius: '3px', backgroundColor: '#0d6efd' }}></div>
                                                        <span className="text-muted small">Otwarcie Konferencji i Keynote</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <div style={{ width: '12px', height: '12px', borderRadius: '3px', backgroundColor: '#6610f2' }}></div>
                                                        <span className="text-muted small">Panel: Przyszłość AI w Biznesie</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <div style={{ width: '12px', height: '12px', borderRadius: '3px', backgroundColor: '#6f42c1' }}></div>
                                                        <span className="text-muted small">Warsztaty Design Thinking</span>
                                                    </div>
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <div style={{ width: '12px', height: '12px', borderRadius: '3px', backgroundColor: '#d63384' }}></div>
                                                        <span className="text-muted small">Sesja Q&A i Zakończenie</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Reports Center Card */}
                                    <div className="col-md-5">
                                        <div className="bg-white p-4 rounded-5 border h-100" style={{ boxShadow: '0 25px 50px -12px rgba(0,0,0,0.2)' }}>
                                            <h5 className="fw-bold mb-2 x-small text-dark opacity-75 text-uppercase ls-1">Centrum Raportów</h5>
                                            <p className="text-muted small mb-4">Pobierz szczegółowe zestawienia w formacie PDF.</p>

                                            <div className="d-flex flex-column gap-3">
                                                <div className="p-3 rounded-4 border d-flex align-items-center justify-content-between hover-scale cursor-pointer" style={{ border: "2px solid #0d6efd", backgroundColor: "rgba(13, 110, 253, 0.02)", boxShadow: "0 10px 30px rgba(13,110,253,0.08)" }}>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="text-primary">
                                                            <FontAwesomeIcon icon={faFilePdf} size="2x" />
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold text-primary">Pełny Raport</div>
                                                            <div className="text-primary opacity-75 x-small" style={{ fontSize: "0.7rem" }}>Wszystkie segmenty w jednym pliku</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="p-3 rounded-4 border d-flex align-items-center justify-content-between hover-scale cursor-pointer bg-white" style={{ boxShadow: "0 10px 30px rgba(0,0,0,0.04)" }}>
                                                    <div className="d-flex align-items-center gap-3">
                                                        <div className="text-dark">
                                                            <FontAwesomeIcon icon={faFileArchive} size="2x" />
                                                        </div>
                                                        <div>
                                                            <div className="fw-bold">Raporty Cząstkowe</div>
                                                            <div className="text-muted x-small" style={{ fontSize: "0.7rem" }}>Paczka ZIP (osobny plik na segment)</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Live Demo Section */}
            <section id="demo-section" ref={demoSectionRef} className="py-5 pt-0 bg-white">
                <div className="container py-5">
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <div className="badge bg-danger bg-opacity-10 text-danger px-3 py-2 rounded-pill fw-bold mb-3 ls-1">LIVE DEMO</div>
                            <h2 className="display-6 fw-bold mb-4">Przekonaj się na własne oczy.</h2>
                            <p className="lead text-secondary">
                                Wciel się w rolę uczestnika. Zeskanuj kod QR swoim telefonem i zobacz, jak Twoje pytania w czasie rzeczywistym trafiają do panelu demo poniżej.
                            </p>
                        </div>
                    </div>

                    <div className="row g-4 align-items-stretch">
                        <div className="col-lg-4">
                            <div className="bg-light p-5 rounded-5 border h-100 d-flex flex-column align-items-center justify-content-center text-center" style={{ borderStyle: 'dashed !important', borderWidth: '2px !important' }}>
                                <h5 className="fw-bold mb-2">Zeskanuj i zadaj pytanie</h5>

                                {sessionId ? (
                                    <>
                                        <div className="bg-white p-3 rounded-4 shadow-sm mb-4">
                                            <QRCode
                                                value={guestUrl}
                                                size={200}
                                                qrStyle="dots"
                                                eyeRadius={10}
                                                quietZone={5}
                                            />
                                        </div>

                                        <p className="text-muted small mb-0 mt-3" onClick={() => { handleCopyLink(); window.open(guestUrl, '_blank'); }} style={{ cursor: 'pointer' }}>
                                            lub kliknij link aby skopiować i otworzyć w nowej karcie: <br />
                                            <strong className={isCopied ? "text-success" : "text-primary"}>
                                                {isCopied ? "Skopiowano do schowka!" : guestUrl}
                                            </strong>
                                        </p>
                                    </>
                                ) : (
                                    <div className="flex-grow-1 d-flex align-items-center justify-content-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Ładowanie...</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-8">
                            <div className="p-4 rounded-5 shadow-lg h-100 overflow-hidden position-relative border" style={{ minHeight: '400px', backgroundColor: '#f0f2f5' }}>
                                {/* Floating Header Card */}
                                <div className="bg-white rounded-4 shadow-sm p-4 mb-4 border d-flex flex-column gap-1">
                                    <span className="text-uppercase text-secondary fw-bold" style={{ fontSize: '0.65rem', letterSpacing: '0.08em' }}>Segment:</span>
                                    <h4 className="fw-bold text-dark m-0">Segment Testowy</h4>
                                </div>

                                <div className="demo-messages-container pr-2" style={{ maxHeight: '280px', overflowY: 'auto' }}>
                                    {messages.length === 0 ? (
                                        <div className="text-center py-5">
                                            <p className="text-secondary opacity-50">Czekam na pierwsze pytanie od Ciebie...</p>
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column gap-3">
                                            {messages.map((msg, idx) => (
                                                <div key={idx} className="demo-message-item animate-slide-up">
                                                    <span className="fw-bold text-dark" style={{ fontSize: '1.1rem' }}>{msg.name || msg.n || 'Gość'}: </span>
                                                    <span className="text-secondary" style={{ fontSize: '1.1rem' }}>{msg.message || msg.m || msg.text || msg.content || ''}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Teaser Section – Hook before FAQ */}
            <section className="bg-white border-top border-light overflow-hidden" style={{ paddingBottom: '100px' }}>
                <div className="container pt-5">
                    <div className="text-center mb-5">
                        <h2 className="display-5 fw-bold mb-4 text-dark mx-auto" style={{ maxWidth: '600px' }}>
                            A to dopiero <span className="text-primary">początek</span>.
                        </h2>
                        <p className="lead text-secondary mx-auto" style={{ maxWidth: '520px' }}>
                            Pokazaliśmy Ci ułamek tego, co potrafi SayQ. Resztę musisz odkryć sam, najlepiej przy swoim następnym wydarzeniu.
                        </p>
                    </div>
                    <img
                        src={SayQFunction}
                        alt="Funkcje SayQ App"
                        className="w-100 d-block mb-5"
                        style={{ objectFit: 'cover' }}
                    />
                </div>
            </section>

            {/* FAQ Section */}
            <section id="faq" className="bg-light border-top" style={{ paddingTop: '4rem', paddingBottom: '120px' }}>
                <div className="container py-5 mt-4">
                    <div className="text-center mb-5">
                        <h2 className="display-6 fw-bold mb-4">Najczęściej zadawane pytania</h2>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="accordion accordion-flush bg-transparent" id="faqAccordion">
                                {faqs.map((f, i) => (
                                    <div key={i} className="accordion-item mb-3 rounded-4 border overflow-hidden shadow-sm">
                                        <h2 className="accordion-header">
                                            <button
                                                className={`accordion-button fw-bold py-4 px-4 ${openFaq === i ? '' : 'collapsed'}`}
                                                type="button"
                                                onClick={() => toggleFaq(i)}
                                                style={{ backgroundColor: '#fff' }}
                                            >
                                                {f.q}
                                            </button>
                                        </h2>
                                        <div className={`accordion-collapse collapse ${openFaq === i ? 'show' : ''}`}>
                                            <div className="accordion-body py-4 px-4 text-secondary lh-lg">
                                                {f.a}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Final CTA / Footer */}
            <footer className="landing-footer py-5 bg-dark text-white border-top border-white border-opacity-10">
                <div className="container text-center" style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
                    <img src={AppIcon} alt="SayQ" className="mb-5" style={{ width: 72, height: 72 }} />
                    <h2 className="display-4 fw-black mb-4 tracking-tight">Gotowy na interakcję?</h2>
                    <p className="lead text-white opacity-75 mb-5 mx-auto" style={{ maxWidth: '600px' }}>
                        Zarejestruj się i przetestuj aplikację przez dwa dni za darmo, lub skontaktuj się z nami, aby wykupić licencję na swoje wydarzenie.
                    </p>
                    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-4 mb-5">
                        <button
                            onClick={() => navigate('/EventRegister')}
                            className="btn btn-primary btn-lg rounded-pill px-5 py-3 fw-bold hover-scale"
                        >
                            Zarejestruj się
                        </button>
                        <button
                            onClick={() => navigate('/kontakt')}
                            className="btn btn-lg rounded-pill px-5 py-3 fw-bold hover-lift text-white"
                            style={{ border: '2px solid #0d6efd', transition: 'background-color 0.2s ease' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(13,110,253,0.15)'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            Skontaktuj się z nami →
                        </button>
                    </div>

                    <div className="pt-5 border-top border-white border-opacity-10 opacity-50 d-flex flex-column flex-md-row justify-content-between align-items-center gap-4">
                        <p className="small mb-0">© 2025 SayQ App. Wszystkie prawa zastrzeżone.</p>
                        <div className="d-flex gap-4">
                            <span onClick={() => navigate('/polityka-prywatnosci')} className="text-white text-decoration-none small hover-text-primary" style={{ cursor: 'pointer' }}>Polityka prywatności</span>
                            <span onClick={() => navigate('/regulamin')} className="text-white text-decoration-none small hover-text-primary" style={{ cursor: 'pointer' }}>Regulamin</span>
                            <a href="https://www.linkedin.com/in/mateusz-krosnowski/" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none small hover-text-primary">
                                Powered by Mateusz Krosnowski
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
